import { useState } from "react";
import img from './img/Career.jpg';
import { FaExclamationTriangle, FaShieldAlt } from "react-icons/fa";
import ResumeUpload from "./ResumeUpload";

const Career = () =>  {

    const [selectedJob, setSelectedJob] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    // Job details
    const jobs = [
        {
            id: 1,
            icon : <FaShieldAlt/>,
            title: "VAPT Analyst",
            description: [
                "As a VAPT Analyst, you will be responsible for identifying, analyzing, and mitigating security vulnerabilities in networks, applications, and systems. You will conduct penetration testing, security assessments, and provide recommendations to enhance cybersecurity defenses. This role requires a strong understanding of ethical hacking methodologies, security tools, and risk assessment techniques."
            ],
            qualifications: ["Degree in Cybersecurity, Information Security, or related field.",
                "preferred certifications: CEH, OSCP, GPEN, eJPT (not mandatory).",
                "Expertise in penetration testing and security standards.",
                "Strong understanding of web security, networking, and cloud security.",
                "Ability to analyze reports and suggest security improvements.",
                "Excellent problem-solving skills and attention to detail."
            ],
            responsibilities: ["Conduct Vulnerability Assessment & Penetration Testing (VAPT) on networks, applications, and cloud environments.",
                "Identify, analyze, and report security vulnerabilities with remediation steps.",
                "Ensure compliance with security standards (OWASP, NIST, ISO 27001).",
                "Collaborate with teams to fix security flaws and strengthen defenses.",
                "Stay updated on cyber threats, exploits, and security trends.",
                "Provide security training and guidance to teams."

            ],
            employeeType: ["Full-Time"],
            location: ["Remote",
                "Hybrid",
                "On-Site",
            ],

        },
        {
            id: 2,
            icon:<FaExclamationTriangle/>,
            title: "Cybersecurity Trainer",
            description: [
                "As a Cybersecurity Trainer, you will be responsible for delivering high-quality training sessions on cybersecurity concepts, ethical hacking, and penetration testing. You will design course materials, conduct hands-on labs, and mentor students in cybersecurity best practices. This role requires expertise in security tools, threat analysis, and a strong passion for teaching and mentoring future cybersecurity professionals"
            ],
            qualifications: ["Degree in Cybersecurity, Information Security, or related field.",
                "Preferred certifications: CEH, OSCP, Security+, CISSP, CHFI (not mandatory).",
                "Strong knowledge of network security, ethical hacking, and penetration testing",
                "Familiarity with OWASP, NIST, ISO 27001, and security framework.",
                "Ability to explain complex cybersecurity concepts in an engaging and simple way.",
                "Strong communication, problem-solving, and mentoring skills."
            ],
            responsibilities: ["Conduct cybersecurity training sessions for students and professionals..",
                "Develop training materials, hands-on labs, and real-world cybersecurity challenges..",
                "Develop training materials, hands-on labs, and real-world cybersecurity challenges.",
                "Stay updated with latest cyber threats, attack techniques, and security trends. ",
                "Conduct assessments, projects, and provide constructive feedback.."

            ],
            employeeType: ["Full-Time"],

            location: ["Remote",
                "Hybrid",
                "On-Site",
            ],
        },
    ];

    return (
      <>
        <div className="job-container pb-3 mt-4">
            {/* Show Job List */}
            {selectedJob === null ? (
                <>
                    {/* <div className="career-info mt-3">
                        <p>
                            Join our team and be part of a mission to secure the digital world! We deliver
                            cutting-edge and legacy security solutions to protect data and operations,
                            ensuring businesses stay ahead of cyber threats. With our expert-managed security
                            services, we provide robust defense strategies tailored to evolving cybersecurity
                            challenges. Explore exciting career opportunities with us and make a real impact
                            in the world of cybersecurity.
                        </p>
                    </div> */}
        <div className="container-fluid pb-5 smooth">
  <div className="container">
    <div className="row g-5 align-items-center">
      
      {/* Left Side - Image */}
      <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
        <div className="about-img">
          <img className="img-fluid" src={img} loading="lazy" alt="About Us" />
        </div>
      </div>

      {/* Right Side - Text Content */}
      <div className="col-lg-6 wow fadeIn animate__animated animate__slideInRight" data-wow-delay="0.5s">
        <h1 className="mb-3 text-start career-head">Career</h1>
        
        <h5 className="mb-3 lh-base text-start">
          Join our team and be part of a mission to secure the digital world!  
          We deliver cutting-edge and legacy security solutions to protect data and operations,  
          ensuring businesses stay ahead of cyber threats.
        </h5>
        
        <h5 className="mb-3 lh-base text-start">
          With our expert-managed security services, we provide robust defense strategies tailored  
          to evolving cybersecurity challenges. Explore exciting career opportunities with us  
          and make a real impact in the world of cybersecurity.
        </h5>

        {/* Social Media Button */}
        <div className="d-flex align-items-center mt-4">
    <a className="btn btn-outline-primary d-flex align-items-center justify-content-center px-3 py-2" 
       target="_blank" 
       href="https://www.linkedin.com/company/cyber-arcadia/about/?viewAsMember=true">
        <i className="fab fa-linkedin-in me-2"></i> 
    </a>
</div>


      </div>
      
    </div>
  </div>
</div>
                    <div className="mt-5">
                    <button className="openings-btn mt-5">Current Openings</button>
                    </div>
                    <div className="job-cards mt-5">
                        {jobs.map((job) => (
                            <div key={job.id} className="job-card" onClick={() => { setSelectedJob(job)
                              window.scrollTo({ top: 0, behavior: "smooth" });
                            }
                            }>
                               <i>{job.icon}</i>
                                <h3>{job.title}</h3>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                // Show Job Details
                <div className="job-details  mt-5" style={{ background: "none", padding: "0", border: "none", boxShadow: "none" }}>

                    <h2 className="mt-3">{selectedJob.title}</h2>

                    <div className="job-section mt-5">
                        <h3>Job Description</h3>
                        <p className="mt-3">{selectedJob.description}</p>
                    </div>

                    <div className="job-section">
                        <h3>Required Qualifications & Skills</h3>
                        <ul className="mt-3">{selectedJob.qualifications.map((q, index) => <li key={index}>{q}</li>)}</ul>
                    </div>


                    <div className="job-section">
                        <h3>Responsibilities</h3>
                        <ul className="mt-3">{selectedJob.responsibilities.map((r, index) => <li key={index}>{r}</li>)}</ul>
                    </div>

                    <div className="job-section">
                        <h3>Employee Type</h3>
                        <ul className="mt-3">{selectedJob.employeeType.map((Emp, index) => <li key={index}>{Emp}</li>)}</ul>
                    </div>

                    <div className="job-section">
                        <h3>Location</h3>
                        <ul className="mt-3">
                            {selectedJob.location.map((loc, index) => (
                                <li key={index}>{loc}</li>
                            ))}
                        </ul>
                    </div>

                    <div className="buttons mt-5">
                      <button className="apply-btn" onClick={() => setIsPopupOpen(true)}>
                            Apply
                        </button>
                        <button
                            className="back-btn"
                            onClick={() => {
                                setSelectedJob(null); // Reset job selection
                                window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top smoothly
                            }}
                        >
                            Back
                        </button>

                    </div>
                    <ResumeUpload isOpen={isPopupOpen} setIsOpen={setIsPopupOpen} />
                </div>
            )}
        </div>
        </>
    );
}

export default Career;